export default __webpack_public_path__ + "static/media/mongodb.0368dd10.svg";